import * as z from "zod";

import { ReferrerSummarySchema } from "../shared/referrer";

export const getMe = {
  name: "getMe" as const,
  input: z.object({}),
  output: z.object({ referrer: ReferrerSummarySchema }),
};
